/**
 * Shown briefly on app boot while `/api/session` is in flight. Intentionally
 * minimal — usually visible for only a few hundred ms.
 */
import { PumpkinFigure } from "@/components/PumpkinFigure";
import "./BootScreen.css";

export function BootScreen() {
  return (
    <main className="boot" aria-busy="true" aria-label="Loading">
      <PumpkinFigure
        className="boot__pumpkin"
        pose="idleDefault"
        alt=""
        aria-hidden="true"
      />
    </main>
  );
}
